import TextField from "@mui/material/TextField";
import { updateSurveyToFillQuestion } from "../../../../../../store/actions/dataEntryFillASurveyActions";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

const SurveyLongQuestion = ({ question, disabled, onChangeAlert }) => {
  const dispatch = useDispatch();
  const { id, config, answer, error } = question;

  const [value, setValue] = useState(
    answer && answer.length ? answer[0] : null
  );

  const onChangeInputValue = (newValue) => {
    dispatch(
      updateSurveyToFillQuestion({
        questionId: id,
        newData: { answer: newValue ? [newValue] : [], error: null },
      })
    );

    onChangeAlert();
  };

  useEffect(() => {
    setValue(answer && answer.length ? answer[0] : null);
  }, [answer]);

  return (
    <>
      <TextField
        id={`long-answer-${id}`}
        name="value"
        value={value || ""}
        placeholder="Enter your answer here"
        onChange={(evt) => onChangeInputValue(evt.target.value)}
        inputProps={{
          required: true,
          maxLength: config?.maxLength || 500,
          spellCheck: false,
        }}
        style={{ mr: 1, width: "100%" }}
        className="custom-text-field"
        multiline
        minRows={3}
        maxRows={12}
        disabled={disabled}
        error={error ? true : false}
        helperText={error}
        variant="standard"
      />
    </>
  );
};

export default SurveyLongQuestion;
